import React from 'react';
import { SUPPORT_EMAIL } from '../data/content';
const LINK_CLASS = 'transition-colors duration-150 ease-soft hover:text-electric';
export function Footer() {
  return <footer className="bg-navy-deep" data-id="element-67" data-mp="32nukakr5twzs">
      <div className="mx-auto max-w-2xl px-4 py-5 text-center text-[0.68rem] leading-snug text-white/60 sm:px-6" data-id="element-68" data-mp="32ovw4rg02nik">
        <p className="font-display font-bold text-white/80" data-id="element-69" data-mp="36q93x72nl0s4">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1.5" data-id="element-70" data-mp="3ucxoy1myl9cy">
          Mega Pack Técnico en Seguridad Electrónica™ es un producto educativo. No
          sustituye formación profesional, práctica supervisada, normativa
          aplicable, licencias, certificaciones, permisos ni el criterio de un
          profesional habilitado. La instalación y manipulación de sistemas
          eléctricos, electrónicos, redes, automatismos y sistemas de seguridad
          puede implicar riesgos. Respeta siempre las indicaciones del fabricante,
          las normas de seguridad y la legislación aplicable.
        </p>
        <p className="mt-1.5" data-id="element-71" data-mp="3la29svmrl5vr">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className={`text-electric ${LINK_CLASS}`} data-id="element-72" data-mp="3gapf5opniuim">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-2 flex flex-wrap items-center justify-center gap-x-2 text-white/75" data-id="element-73" data-mp="3v9b1tiy2kafh">
          <a href="#terminos" className={LINK_CLASS} data-id="element-74" data-mp="82qp7jv45dpi">
            Términos y Condiciones
          </a>
          <span aria-hidden="true" data-id="element-75" data-mp="34gvldp1el60">•</span>
          <a href="#privacidad" className={LINK_CLASS} data-id="element-76" data-mp="33e4b4nsygpk">
            Política de Privacidad
          </a>
          <span aria-hidden="true" data-id="element-77" data-mp="hs1xj4a6eecc">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className={LINK_CLASS} data-id="element-78" data-mp="cu0icufvez65">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}